var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 26.4 120 52.8 120 80 C80.4 80 40.8 80 0 80 C0 53.6 0 27.2 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C13.2 0 26.4 0 40 0 C40 26.4 40 52.8 40 80 C26.8 80 13.6 80 0 80 C0 53.6 0 27.2 0 0 Z ",
    fill: "#CE2B37",
    transform: "translate(80,0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C13.2 0 26.4 0 40 0 C40 26.4 40 52.8 40 80 C26.8 80 13.6 80 0 80 C0 53.6 0 27.2 0 0 Z ",
    fill: "#009246",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.2abb57fee77c316c4b4a670d25fff2fb.svg";
export { ForwardRef as ReactComponent };